import { NeoFacetRequestApiModel } from '../../../api/mentions/model/neo-facet-request-api.model';
import { NeoFacetDateFieldApiEnum } from '../../../api/mentions/model/neo-facet-date-field-api.enum';
import { NeoFacetTermFieldApiEnum } from '../../../api/mentions/enum/neo-facet-term-field-api.enum';
import { BucketFunctionApiEnum } from '../../../api/mentions/enum/bucket-function-api.enum';
import { EngagementAgeApiEnum } from '../../../api/mentions/enum/engagement-age-api.enum';
import { ReportsNeoFacetKeys } from '../enums/reports-neo-facet-keys.enum';
import { AggregateBucketRequestApiModel } from '../../../api/mentions/model/aggregate-bucket-request-api.model';


export const sentimentTrendNeoFacet: NeoFacetRequestApiModel = {
    dateField: NeoFacetDateFieldApiEnum.CREATED_AT,
    key: ReportsNeoFacetKeys.sentimentOverTime,
    plainBucketRequests: [
        {
            key: ReportsNeoFacetKeys.sentimentTrend,
            field: NeoFacetTermFieldApiEnum.SENTIMENT
        }
    ]
};

export const engagementsNeoFacet: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.MEDIA_TYPE,
    key: ReportsNeoFacetKeys.mediaTypeEngagements,
    engagementBucketRequests: [
        {
            key: ReportsNeoFacetKeys.engagementTotal,
            field: NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: ReportsNeoFacetKeys.engagementTotalLikes,
            field: NeoFacetTermFieldApiEnum.LIKE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: ReportsNeoFacetKeys.engagementTotalReply,
            field: NeoFacetTermFieldApiEnum.REPLY,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: ReportsNeoFacetKeys.engagementTotalQuotes,
            field: NeoFacetTermFieldApiEnum.QUOTE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: ReportsNeoFacetKeys.engagementTotalShare,
            field: NeoFacetTermFieldApiEnum.SHARE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: ReportsNeoFacetKeys.engagementTotalView,
            field: NeoFacetTermFieldApiEnum.VIEW,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
    ]
};

// Engagements aggregate bucket requests for saved mentions
// These requests are added to engagementsNeoFacet.aggregateBucketRequests for saved mentions.
export const engagementsAggregateBucketRequests: AggregateBucketRequestApiModel[] = [
    {
        key: ReportsNeoFacetKeys.mediaTypeEngagements,
        field: NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL,
        function: BucketFunctionApiEnum.INDIVIDUAL_SUM
    },
];

export const audienceReachNeoFacet: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
    key: ReportsNeoFacetKeys.audienceReach,
};

export const socialCoverageByNetworkNeoFacet: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.MEDIA_TYPE,
    key: ReportsNeoFacetKeys.socialCoverageByNetwork,
    engagementBucketRequests: [
        {
            key: ReportsNeoFacetKeys.mediaTypeEngagements,
            field: NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // likes
            key: ReportsNeoFacetKeys.engagementTotalLikes,
            field: NeoFacetTermFieldApiEnum.LIKE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // quotes
            key: ReportsNeoFacetKeys.engagementTotalQuotes,
            field: NeoFacetTermFieldApiEnum.QUOTE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // replies
            key: ReportsNeoFacetKeys.engagementTotalReply,
            field: NeoFacetTermFieldApiEnum.REPLY,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // retweets
            key: ReportsNeoFacetKeys.engagementTotalShare,
            field: NeoFacetTermFieldApiEnum.SHARE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // views
            key: ReportsNeoFacetKeys.engagementTotalView,
            field: NeoFacetTermFieldApiEnum.VIEW,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ],
    aggregateBucketRequests: [
        {
            key: ReportsNeoFacetKeys.mediaTypeImpressions,
            field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ]
};

export const coverageOverTimeNeoFacet: NeoFacetRequestApiModel = {
    dateField: NeoFacetDateFieldApiEnum.CREATED_AT,
    key: ReportsNeoFacetKeys.overtimeFacet,
    engagementBucketRequests: [
        {
            key: ReportsNeoFacetKeys.engagementsOverTimeFacet,
            field: NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // likes
            key: ReportsNeoFacetKeys.engagementTotalLikes,
            field: NeoFacetTermFieldApiEnum.LIKE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // quotes
            key: ReportsNeoFacetKeys.engagementTotalQuotes,
            field: NeoFacetTermFieldApiEnum.QUOTE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // replies
            key: ReportsNeoFacetKeys.engagementTotalReply,
            field: NeoFacetTermFieldApiEnum.REPLY,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // retweets
            key: ReportsNeoFacetKeys.engagementTotalShare,
            field: NeoFacetTermFieldApiEnum.SHARE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // views
            key: ReportsNeoFacetKeys.engagementTotalView,
            field: NeoFacetTermFieldApiEnum.VIEW,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ],
    aggregateBucketRequests: [
        {
            key: ReportsNeoFacetKeys.impressionsOverTimeFacet,
            field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: ReportsNeoFacetKeys.aveOverTimeFacet,
            field: NeoFacetTermFieldApiEnum.AD_VALUE_USD,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ]
};

// Aggregate bucket requests for Social Metrics (used in saved mentions).
// These requests are added to coverageOverTimeNeoFacet.aggregateBucketRequests for saved mentions.
export const socialMetricsAggregateBucketRequests: AggregateBucketRequestApiModel[] = [
    {
        key: ReportsNeoFacetKeys.engagementsOverTimeFacet,
        field: NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL,
        function: BucketFunctionApiEnum.INDIVIDUAL_SUM
    },
    {   // likes
        key: ReportsNeoFacetKeys.engagementTotalLikes,
        field: NeoFacetTermFieldApiEnum.LIKE,
        function: BucketFunctionApiEnum.INDIVIDUAL_SUM
    },
    {   // quotes
        key: ReportsNeoFacetKeys.engagementTotalQuotes,
        field: NeoFacetTermFieldApiEnum.QUOTE,
        function: BucketFunctionApiEnum.INDIVIDUAL_SUM
    },
    {   // replies/comments
        key: ReportsNeoFacetKeys.engagementTotalReply,
        field: NeoFacetTermFieldApiEnum.REPLY,
        function: BucketFunctionApiEnum.INDIVIDUAL_SUM
    },
    {   // shares/retweets/reposts
        key: ReportsNeoFacetKeys.engagementTotalShare,
        field: NeoFacetTermFieldApiEnum.SHARE,
        function: BucketFunctionApiEnum.INDIVIDUAL_SUM
    },
    {   // views
        key: ReportsNeoFacetKeys.engagementTotalView,
        field: NeoFacetTermFieldApiEnum.VIEW,
        function: BucketFunctionApiEnum.INDIVIDUAL_SUM
    }
];

export const totalEngagementFacet: NeoFacetRequestApiModel = {
    dateField: NeoFacetDateFieldApiEnum.CREATED_AT,
    key: ReportsNeoFacetKeys.totalEngagements,
    engagementBucketRequests: [
        {
            key: ReportsNeoFacetKeys.mediaTypeEngagements,
            field: NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ],
    aggregateBucketRequests: []
};

export const mapChartNeoFacet: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.COUNTRY,
    key: NeoFacetTermFieldApiEnum.COUNTRY,
    aggregateBucketRequests: [
        {
            key: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: NeoFacetTermFieldApiEnum.AD_VALUE_USD,
            field: NeoFacetTermFieldApiEnum.AD_VALUE_USD,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ]
};

export const topOutletsNeoFacetRequest: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.OUTLET_NAME,
    key: NeoFacetTermFieldApiEnum.OUTLET_NAME_FACET,
    aggregateBucketRequests: [
        {
            key: NeoFacetTermFieldApiEnum.AD_VALUE_USD,
            field: NeoFacetTermFieldApiEnum.AD_VALUE_USD,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: NeoFacetTermFieldApiEnum.DOMAIN_AUTHORITY,
            field: NeoFacetTermFieldApiEnum.DOMAIN_AUTHORITY,
            function: BucketFunctionApiEnum.INDIVIDUAL_MAX
        },

    ],
    plainBucketRequests: [
        {
            key: NeoFacetTermFieldApiEnum.OUTLET_NAME_X_OUTLET_UUID,
            field: NeoFacetTermFieldApiEnum.OUTLET_UUID
        }
    ]
};

export const topContactsNeoFacetRequest: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.CONTACT_NAME,
    key: NeoFacetTermFieldApiEnum.CONTACT_NAME,
    aggregateBucketRequests: [
        {
            key: NeoFacetTermFieldApiEnum.AD_VALUE_USD,
            field: NeoFacetTermFieldApiEnum.AD_VALUE_USD,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {
            key: NeoFacetTermFieldApiEnum.DOMAIN_AUTHORITY,
            field: NeoFacetTermFieldApiEnum.DOMAIN_AUTHORITY,
            function: BucketFunctionApiEnum.INDIVIDUAL_MAX
        },

    ],
    plainBucketRequests: [
        {
            key: NeoFacetTermFieldApiEnum.CONTACT_NAME_X_CONTACT_UUID,
            field: NeoFacetTermFieldApiEnum.CONTACT_UUID
        }
    ]
};
